(function () {
  // var supportOffset = window.pageYOffset !== undefined,
  //   lastKnownPos = 0,
  //   ticking = false,
  //   scrollDir,
  //   currYPos;

  // function doSomething(scrollPos, scrollDir) {
  //   // Your code goes here...
  //   // console.log('scroll pos: ' + scrollPos + ' | scroll dir: ' + scrollDir);
  //   if (scrollPos >= 200 && scrollDir == 'down') {

  //     $('.main-header-inner').css({ "background-color": "#0B2538" });
  //     $('.menu').removeClass('nav-top');
  //     $('.big-logo').css({ "display": "none" });
  //     $('.small-logo').css({ "display": "block" });
  //     $('#sticky-header').addClass('small-header');

  //   }

  //   if (scrollPos <= 200 && scrollDir == 'up') {

  //     $('#sticky-header').removeClass('small-header');
  //     $('.main-header-inner').css({ "background-color": "unset" });
  //     $('.menu').addClass('nav-top');
  //     $('.small-logo').css({ "display": "none" });
  //     $('.big-logo').css({ "display": "block" });

  //   }

  // }

  // scroller.on("scroll", (e) => {
  //   currYPos = supportOffset ? window.pageYOffset : document.body.scrollTop;
  //   scrollDir = lastKnownPos > currYPos ? 'up' : 'down';
  //   lastKnownPos = currYPos;

  //   if (!ticking) {
  //     window.requestAnimationFrame(function () {
  //       doSomething(lastKnownPos, scrollDir);
  //       ticking = false;
  //     });
  //   }
  //   ticking = true;
  // })

  // window.addEventListener('scroll', function (e) {

  // });
})();


// slider

$('.new-slider').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
  adaptiveHeight: false,
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 1000,



  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 1000,
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 1000,
      }
    }
  ]
});

$('.new-slider-ar').slick({
  centerMode: true,
  centerPadding: '60px',
  slidesToShow: 3,
  adaptiveHeight: false,
  arrows: true,
  rtl: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 1000,



  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        rtl: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 1000,
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        rtl: true,
        centerPadding: '40px',
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 1000,
      }
    }
  ]
});


document.addEventListener("DOMContentLoaded", () => {

  const nav = document.querySelector(".nav");
  const [html] = document.getElementsByTagName("html");
  const lang = html.getAttribute("lang");

  // Mobile menu
  document.querySelector("#btnNav").addEventListener("click", () => {
    nav.classList.add("nav--open");
  });

  document.querySelector(".nav__overlay").addEventListener("click", () => {
    nav.classList.remove("nav--open");
  });

  // Mobile menu close icon click events
  if (lang) {
    if (lang == 'ar') {
      document.querySelector('.close_ar').addEventListener("click", () => {
        nav.classList.remove("nav--open");
      });

    }

    if (lang == 'en') {
      document.querySelector('.close').addEventListener("click", () => {
        nav.classList.remove("nav--open");
      });
    }
  }

  //Mobile Menu click events
  var a = document.querySelector('#a'),
    e = document.querySelector('#e'),
    s = document.querySelector('#s'),
    i = document.querySelector('#i'),
    c = document.querySelector('#c'),
    ev = document.querySelector('#ev'),
    co = document.querySelector('#co'),
    con = document.querySelector('#con');

  if (a) {
    document.querySelector('#a').addEventListener("click", () => {
      wi
      nav.classList.remove('nav--open');
    });
  }

  if (e) {
    document.querySelector('#e').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

  if (s) {
    document.querySelector('#s').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

  if (i) {
    document.querySelector('#i').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

  if (c) {
    document.querySelector('#c').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

  if (ev) {
    document.querySelector('#ev').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

  if (co) {
    document.querySelector('#co').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

  if (con) {
    document.querySelector('#con').addEventListener("click", () => {
      nav.classList.remove('nav--open');
    });
  }

});


// Wrap every img in a figure tag
// 1. For all images with class .main-content img
// 2. Wrap them in a figure
//  $(".main-content img").wrap('<div class="image-container" >');
// Add alt text after each img
// 1. For all items with class .main-content img
// 2. Run a function for each of them...
// 3. To add a p element after it
// 5. Containing that element's alt text
// $(".main-content img").each(function() {
//     if( $(this).attr('alt') ) {
//         $(this).wrap('<div class="image-container" style="margin:10px 10px 30px 10px;'+$(this).attr('style')+'">');
//         $(this).after('<div class="caption" >' + $(this).attr('alt') + '</div>');

//     }  
//  })

$(document).ready(function () {
  var _intervalId;
  function fadeInLastImg() {
    var backImg = $('#scroll-image img:first');
    backImg.hide();
    $('#scroll-image').append(backImg);
    backImg.fadeIn()
  };
  _intervalId = setInterval(function () {
    fadeInLastImg();
  }, 3000);

  $(".news-box p a").attr("target", "_blank");

  //  fsLightbox.props.type = 'video';
  //  fsLightbox.props.slideDistance = 0.5;
  //  fsLightbox.props.exitFullscreenOnClose = true;

  if (window.location.href.indexOf("uk-saudi-renewable-energy-forum") > -1) {
    document.getElementById('gallery-tabs').remove();
  }

});

$('#map-slider-ar').slick({
  slidesToShow: 1,
  rtl: true,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
});

// Expertise slider English
$('#expertise-slider').slick({
  slidesToShow: 1,
  dots: false,
  arrows: true,
  infinite: true,
  slidesToScroll: 1,
  prevArrow: $(".pp2"),
  nextArrow: $(".nn2"),

});

// Expertise slider Arabic
$('#expertise-slider-ar').slick({
  slidesToShow: 1,
  rtl: true,
  dots: false,
  arrows: true,
  infinite: true,
  slidesToScroll: 1,
  prevArrow: $(".pp2"),
  nextArrow: $(".nn2"),
});

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.getElementsByClassName('gallery');
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', tabSwitch, false);
  }

  function tabSwitch() {
    document.getElementsByClassName('is-active')[0].classList.remove('is-active');
    this.classList.add('is-active');
    document.getElementsByClassName('is-show')[0].classList.remove('is-show');
    const arrayTabs = Array.prototype.slice.call(tabs);
    const index = arrayTabs.indexOf(this);
    document.getElementsByClassName('gallery-content')[index].classList.add('is-show');
  };
}, false);